import React, { Component } from 'react';
import { Row, Col, Form, Input, DatePicker, Checkbox, TimePicker, Mention, Drawer, Divider } from 'antd';
import Button from '../common/atoms/DSButton';
import Select from 'antd/lib/select';
import moment from 'moment';
import UserLocationModal from './UserLocationModal'
import update from 'immutability-helper'; 
import { List, message, Spin, } from 'antd';
import InfiniteScroll from 'react-infinite-scroller';
import notification from 'antd/lib/notification'
import { employeeDataApi } from '../../services';
import { handleAppError } from '../handlers';
import * as Yup from "yup";
const Option = Select.Option;
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const format = 'HH:mm';
const { toString } = Mention;
const { TextArea } = Input;

class RescheduledAppointmentDrawer extends Component {
  constructor(props) {
      super(props);
      this.state = {
        appointment: {appointment_date: '', time: '', enterprises_id: [], provider_id: ''},
        loading: false,
        apt_date: [],
        apt_time: ["08", "00"],
        disrupted_dates: [],
        holiday_days: [],
        providerName: null,
        selectProvider: false,
        hasmore: true,
        enterprise_id: '',
        provider: '',
        date: '',
        time: '',
        comment: '',
        service_mode: '',
        packageId: '',
        enterprise: '',
        enterprises: [],
        providers: [],
        selectedProvider: {},
        sendCommunication: true,
        timeFrame: { opening_time: null, closing_time: null },
        apt_id: '',
        appointmentee_id: '',
        package_ids: '',
        package_id: ''
      };
  }
  

  componentDidMount() {
    this.setState({apt_id: this.props.appointment?.id, appointmentee_id: this.props.appointment?.appointmentee_id,
                    package_ids: this.props.appointment?.package_ids, package_id: this.props.appointment?.package_id })
    if(this.props.appointment?.appointmentee_id) this.getEnterprises();
  }

  fetchProvider = (appointmentee_id, appointment_id, enterpriseId) => {
    let zipcode = this.props?.appointment?.zip_code
    let apiData = {
        customerId: appointmentee_id,
        appointmentId: appointment_id,
        enterpriseId: enterpriseId
      }

    if (zipcode) { apiData['pincode'] = zipcode }
    
      employeeDataApi.fetch_providers({...apiData}, (response) => {
        let { data } = response
        data = data.sort((a, b) => {
            let aPriority = a.priority_pincodes?.includes(zipcode) ? a.priority : 1;
            let bPriority = b.priority_pincodes?.includes(zipcode) ? b.priority : 1;
            return bPriority - aPriority;
          })
          this.setState({providers: data})
        }, (err) => {
        handleAppError(err)
      })
  }

  getEnterprises = () => {
    let apiData =  
    {
      appointmentee_id: this.props.appointment?.appointmentee_id,
      id: this.props.appointment?.id
    }
    
    employeeDataApi.fetch_enterprise({...apiData}, (response) => {
      let { data } = response
        this.setState({enterprises: data ?? []})
      }, (err) => {
      handleAppError(err)
    })
  }

  validate = () => {
    if(this.state.appointment.provider_id === ''){
      notification['error']({
        message: 'Provider should not be empty',
        description: "Please select provider"
      })
      return false
    }
    if(this.state.apt_date.length === 0){
      notification['error']({
        message: 'Appointment Date should not be empty',
        description: "Please select date"
      })
      return false
    }
    if(this.state.apt_time.length === 0){
      notification['error']({
        message: 'Appointment time should not be empty',
        description: "Please select time"
      })
      return false
    }
    return true
  }

  rescheduleAppointment = () => {
    if(this.validate()){
      let that = this
      that.setState({ loading: true });
      const body = {} 
      let date = this.state.apt_date
      let time = this.state.apt_time
      let appt_date = date[0] + "-" + date[1] + "-" + date[2]
      let appt_time = new Date(parseInt(date[0]), parseInt(date[1])-1, parseInt(date[2]), parseInt(time[0]),parseInt(time[1]), 0)
      body['date'] = appt_date
      body['time'] = appt_time
      body['provider'] = this.state.appointment.provider_id
      body['customer_id'] = this.props.appointment?.appointmentee_id
      body['skip_communication'] = false
      body['vendor_status'] = 'reschedule'
      body['id'] = this.props.appointment?.id

      employeeDataApi.reschedule_appointment({
            data: body
          }, (response) => {
            that.setState({loading: false})
            that.props.postUpdate('reschedule')
          }, (err) => {
            handleAppError(err)
            that.props.postUpdate('reschedule')
          }) 
    }
}

  handleInfiniteOnLoad = () => {
    let data = this.state.providers;
    this.setState({
      loading: true,
    });
    if (data.length > 14) {
      message.warning('Infinite List loaded all');
      this.setState({
        hasMore: false,
        loading: false,
      });
      return;
    }
    this.fetchData((res) => {
      data = data.concat(res.results);
      this.setState({
        data,
        loading: false,
      });
    });
  }

  disableDateTime() {
    var tempDate = new Date();
    var newTime = parseInt(tempDate.getHours());
    if (newTime >= 15){
      let dates = this.state.disrupted_dates
      dates.push(new Date(tempDate.getFullYear(), tempDate.getMonth(),tempDate.getDate() + 1))
      dates.push(new Date())
      this.setState({disrupted_dates: dates})
    }
  }

  updateEntyerpriseId = (value) => {
    let updated = update(this.state.appointment, {enterprises_id: {$set: value }})
    this.setState({appointment: updated, enterprise_id: value})
  }

  updateProvider = (id, name) => {
    let provider = this.state.providers.find((provider) => { return provider.id === id })
    let disrupted_dates = provider.disrupted_dates
    let holiday_days = provider.holiday_days
    let updated = update(this.state.appointment, {provider_id: {$set: id}})
    this.setState({appointment: updated, disrupted_dates: disrupted_dates, holiday_days: holiday_days},function(){
      this.disableDateTime()
    })

    this.setState({providerName: name})
    this.setState({selectProvider: false})
  }

  updateDate = (date,dateString) => {
    let updated = update(this.state.appointment, {appointment_date: {$set: dateString }})
    let items = dateString.split("-")
    this.setState({appointment: updated, apt_date: items})
  }

  updateTime = (hours,minutes) => {
    let updated = update(this.state.appointment, {time: {$set: hours }})
    let items = minutes.split(":")
    this.setState({appointment: updated, apt_time: items})
  }

  disabledDisruptedDates = current => {
    if ( current && current < moment().endOf('day')){
      return current
    }
    else if (current && this.state.holiday_days.length > 0 && this.state.holiday_days.includes(current._d.getDay())){
      return current 
    }
    else if (current && this.state.disrupted_dates.some(date => moment(date).format("DDMMYYYY") === moment(current._d).format("DDMMYYYY"))) {
      return current
     }
     else if (!(moment(current) >= moment().add(0,'days') && moment(current)<= moment().add(30,'days'))){
      return current
     }else{
      return false
    }
  }

  disabledDate(current) {
    // Can not select days before today and today
    return current && current < moment().endOf('day');
  }

  disabledHours() {
    var hours = [];
    var time = [8,9];
    for(var i=0; i < 23; i++){
      let a = time.includes(i)
      if(!a ) {
        hours.push(i);
      }
    }
    return hours;
  }

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  showChildrenDrawer = () => {
    this.setState({
      childrenDrawer: true,
    });
  };

  onChildrenDrawerClose = () => {
    this.setState({
      selectProvider: false,
    });
  };

  chooseProvider () {
  this.setState({selectProvider: true})
  this.fetchProvider( this.state.appointmentee_id,
                      this.state.apt_id,
                      this.state.enterprise_id)
  }

  renderSelectedProvider(){
    if(this.state.providerName != null){
    return(
    <div>
      <Row>
      <Col span={24} style={{paddingTop: 20}}>
        <label style={{marginTop: 20,color: '#6B7280'}}>PROVIDER</label><br/>
        <TextArea
         placeholder={this.state.providerName}
         style={{marginTop: 5}}
         autosize
         readOnly
         />
      </Col>
      </Row>
      <br/>
    </div>
    )
    }
  }

  renderButtonProvider(){
      return(
        <div className='mt-6 -mx-3'>
          <Button id="providerButton" type="" style={{width: '100%', height: '60px', fontWeight: 600, borderRadius: '6px',  fontSize: 16}} onClick={this.chooseProvider.bind(this)}>
            {this.state.providerName != null ? 'Change provider' : 'Choose provider'}
          </Button>
        </div>
      )
  }
         

  renderAppointmentDateTime(){
    const formItemLayout = null;
    if(this.state.appointment.provider_id != ''){
      return(
        <div>
          <Row gutter={24}>
            <Col className="gutter-row" span={12} style={{paddingTop: 20}}>
              <label style={{marginTop: 20,color: '#6B7280'}}>APPOINTMENT DATE </label><br/>
                <DatePicker disabledDate={this.disabledDisruptedDates} onChange={this.updateDate} style={{width: '100%',marginTop: 10}}/>
            </Col>
            <Col className="gutter-row" span={12} style={{paddingTop: 20}} justify="end"> 
                <label style={{marginTop: 20,color: '#6B7280'}}>APPOINTMENT TIME</label><br/>
                <TimePicker disabledHours={this.disabledHours} defaultValue={moment('8:00', format)}  onChange={this.updateTime} format={format} style={{width: '100%',marginTop: 10}}/>
            </Col>
          </Row> 
        </div>
      )
    }else{
      return(
        <div>
          <Row gutter={24}>
            <Col className="gutter-row" span={12} style={{paddingTop: 20}}>
                <label style={{marginTop: 20,color: '#6B7280'}}>APPOINTMENT DATE</label><br/>
                <DatePicker disabledDate={this.disabledDisruptedDates} onChange={this.updateDate} style={{width: '100%',marginTop: 10}} disabled/>
            </Col>
            <Col className="gutter-row" span={12} style={{paddingTop: 20}}> 
                <label style={{marginTop: 20,color: '#6B7280'}}>APPOINTMENT TIME</label><br/>
                <TimePicker disabledHours={this.disabledHours} defaultValue={moment('8:00', format)}  onChange={this.updateTime} format={format} style={{width: '100%',marginTop: 10}} disabled/>
            </Col>
          </Row>
        </div>
      )
    }
  }

  render() {
    let that = this

    return (
      <div className='-m-8 px-10 py-8' style={{background: '#F9FAFB'}}>
        <form>
        <div className='mt-6 mb-3'>
            <label style={{marginTop: 20,color: '#6B7280'}}>ENTERPRISE</label><br/>
              <Select
                showSearch
                value={this.state.appointment.enterprises_id}
                className="form-control"
                placeholder="Select Enterprise"
                onChange={this.updateEntyerpriseId}
                optionFilterProp="children"
                style={{marginTop: 10, backgroundColor: '#fff'}}
                size='large'
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                {
                  that.state.enterprises.map((e) => {
                    return(<Option key={e.id} value={e.id}>{e.name}</Option>)
                  })
                }
              </Select>
        </div>
        {this.renderSelectedProvider()}
        {this.renderButtonProvider()}
        {this.renderAppointmentDateTime()}
          <Drawer
            width={'30%'}
            closable={true}
            onClose={this.onChildrenDrawerClose}
            visible={this.state.selectProvider}
          >
                  <div> 
        <h2 style={{marginBottom: 24}} className="text-ts-xl font-fig-semibold text-gray-900">  Choose providers </h2>          
         <div className="demo-infinite-container" style={{paddingTop: 70}}>
          <InfiniteScroll
            initialLoad={false}
            pageStart={0}
            loadMore={this.handleInfiniteOnLoad}
            hasMore={!this.state.loading && this.state.hasMore}
            useWindow={false}
          >
            <List 
              dataSource={this.state.providers}
              renderItem={item => (
                <List.Item key={item.id} className="style-list-grid" style={{paddingLeft: 6, marginTop: 6}}>

                  <a onClick={this.updateProvider.bind(this, item.id, item.name)}>
                  <List.Item.Meta
                    title={item.name}
                  />
                  </a>
                </List.Item>

              )}
            >
              {this.state.loading && this.state.hasMore && (
                <div className="demo-loading-container">
                  <Spin />
                </div>
              )}
            </List>
          </InfiniteScroll>
        </div>
      </div>
          </Drawer>
          <div className='sticky bottom-0 left-0 z-10 py-2 px-4 bg-white -mx-6 my-4'>
          <Button key="submit" type="primary" style={{width: '100%', height: '60px', fontWeight: 600, borderRadius: '6px', fontSize: 16}} loading={this.state.loading} onClick={this.rescheduleAppointment}>
            Reschedule appointment
          </Button>
        </div>
          </form>
      </div>
    );
  }
}

export default RescheduledAppointmentDrawer;